<template>
  <div class="side-center-modal side-center-modal-share-slide">
    <div>
      <div class="side-center_title mb-4">
        {{ $i18nPresenter.t("Anyone with the link can view your slides with audience responses.") }}
      </div>
      <ShareACopy
        :from="'SideCenterShareSlides'"
        :presentation="presentation"
        :hideSentToTeam="true"
        :hideTitle="true"
      />
    </div>
    <div class="mt-6">
      <div class="side-center_title">
        <div class="text-primary-90 cursor-pointer hover:text-primary-100 font-bold" @click="openExport()">
          <i class="fas fa-download fa-fw"></i> {{ $i18nPresenter.t("Export as...") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ShareACopy from '@/components-v2/presentation-editor/collaboration/ShareACopy.vue'
import Utils from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  name: 'SideCenterShareSlides',
  components: { ShareACopy },
  props: {
    presentation: {
      type: Object,
      default: () => {},
    },
    source: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
  },
  methods: {
    openExport() {
      this.$emit('hideModal')
      if (!this.source) {
        Utils.mixpanelTracking(
          eventCategories.PRESENTATION_EDITOR,
          'Share menu > Share slides > Export as',
          null,
          null,
          {
            presentationId: this.presentation.id,
            userId: this.currentUser.id,
            isPresentationOwner: this.presentation.userId === this.currentUser.id,
          },
        )
        this.$store.state.presentation.showExport = true
      } else if (this.source === 'presentations-list') {
        this.$router.push({
          name: 'PresentationDetail',
          params: {
            id: this.presentation.id,
          },
          query: {
            report: true,
          },
        })
        Utils.mixpanelTracking(
          eventCategories.PRESENTATION_LIST,
          'Share menu > Share slides > Export as',
          null,
          null,
          {
            presentationId: this.presentation.id,
            userId: this.currentUser.id,
            isPresentationOwner: this.presentation.userId === this.currentUser.id,
          },
        )
      }
    },
  },
}
</script>

<style scoped lang="scss">
.side-center-modal-share-slide {
  .side-center_title {
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: left;
    margin-bottom: 12px;
  }
}
</style>
